<template>
  <div :class="slideImgStyle" v-if="isImg">
    <picture>
      <source media="(min-width:0) and (max-width:1023px)" :srcset="mediaMobile"/>
      <source media="(min-width:1024px)" :srcset="item | mgnlMedia('url')"/>
      <pg-image :lazy-src="item | mgnlMedia('url')"
                :alt="itemAltText ? itemAltText : $options.filters.mgnlMedia(this.item, 'title')"
                fetchpriority="high"
      ></pg-image>
    </picture>
  </div>
  <div class="slide-img__video" v-else>

    <vue-vimeo-player v-if="videoShouldBeLoaded"
                      @error="handlePlayerError"
                      @ready="onReady"
                      ref="player"
                      :video-id="videoSource"
                      :player-height="height"
                      :options="!vimeoControls ? options : ''"
                      :controls="vimeoControls"
                      :style="previewImage"
    ></vue-vimeo-player>

    <div v-if="!vimeoControls" class="toggle-mute">
      <button @click="unmute()" type="button" v-if="isInMute">
        <i class="icon icon-mute">
          <span class="show-for-sr">unmute</span>
        </i>
      </button>
      <button v-else @click="mute()" type="button">
        <i class="icon icon-unmute">
          <span class="show-for-sr">mute</span></i>
      </button>
    </div>


    <div v-if="!vimeoControls" class="toggle-play">
      <button @click="pause()" type="button" v-if="isInPlay" :aria-label="$msg('common.heroheading.video.pause.aria')" tabindex="0">
        <i class="icon icon-pause">
          <span class="show-for-sr">pause</span>
        </i>
      </button>
      <button @click="play()" type="button" v-else style="color:#fff" :aria-label="$msg('common.heroheading.video.play.aria')" tabindex="0">
        <i class="icon icon-play">
          <span class="show-for-sr">play</span>
        </i>
      </button>
    </div>


  </div>
</template>


<script>
import PgImage from "../Image/Image.vue";
import PgButton from "../Button/Button.vue";
import {vueVimeoPlayer} from 'vue-vimeo-player'

export default {
  name: "SlideImgVideoAdvanced",
  components: {
    PgImage,
    PgButton,
    vueVimeoPlayer
  },
  data() {
    return {
      height: '100%',
      options: {
        muted: true,
        loop: true,
        autopause: false
      },
      playerReady: false,
      isInPlay: false,
      isInMute: true
    }
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    itemMobile: {
      type: Object,
      default: () => ({})
    },
    itemAltText: {
      type: String
    },
    audioVideo: {
      type: Boolean,
      required: false,
      default: false
    },
    vimeoControls: {
      type: Boolean,
      default: false
    },
    slideNum: {
      type: Number
    },
    currentSlide: {
      type: Number
    },
    hideGradient: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isImg() {
      return (
          (this.item && this.item.type === "image" &&
              (this.itemMobile.type !== "externalvideo" || this.itemMobile.type === "undefined" || this.$mq === "large")) ||
          (this.$mq !== "large" && this.itemMobile && this.itemMobile.type === "image")
      );
    },
    previewImage() {
      let preview;
      if (this.$mq == "small") {
        preview = this.mediaMobile;
      } else {
        preview = this.item.previewImage !== "undefined" ? this.item.previewImage : item | this.$options.filters.mgnlMedia('url');
      }
      return `background:url(${preview}) transparent 0 0;background-size: cover;`;
    },
    mediaMobile() {
      return this.$options.filters.mgnlMedia(
          this.itemMobile || this.item,
          "url"
      );
    },
    videoShouldBeLoaded() {
      this.autoplayVideo ? this.isInPlay = true : this.isInPlay = false;
      return this.slideNum === this.currentSlide;
    },
    slideImgStyle() {
      return ["slide-img__image", this.hideGradient ? "slide-img__image--no-gradient" : ""]
    },
    videoSource() {
      const path = "https://vimeo.com/";
      let videoPath =
          (this.$mq !== "large" && this.itemMobile && this.itemMobile.url) ||
          this.item.url;
      let videoId = videoPath && videoPath.substr(path.length, videoPath.length);

      return videoId;
    },
    toggleLabel() {
      const labelKey = this.isVideoPaused
          ? "common.heroheading.video.play.aria"
          : "common.heroheading.video.pause.aria";
      return this.$msg(labelKey);
    }
  },
  methods: {
    onReady() {
      if (this.autoplayVideo) this.isInPlay = true;
      this.playerReady = true
    },
    play() {
      this.$refs.player && this.$refs.player.play();
      this.isInPlay = true;
    },
    pause() {
      this.$refs.player && this.$refs.player.pause();
      this.isInPlay = false;
    },
    mute() {
      this.$refs.player && this.$refs.player.mute();
      this.isInMute = true;
    },
    unmute() {
      this.$refs.player && this.$refs.player.unmute();
      this.isInMute = false;
    },
    handlePlayerError(err) {
      if(err) {
        const iFrame = this.$refs.player.$el.getElementsByTagName('iframe');
        if(iFrame.length > 0) {
          iFrame[0].style.display = 'none';
        }
      }
    }
  },
  mounted() {
    if (this.autoplayVideo) this.isInPlay = true;

    if (this.audioVideo) {
      this.unmute();
    }
  },
  watch: {
    videoSource() {
      //this.player && this.player.unload();
      this.playerReady = false;
      this.$nextTick(() => {
        return this.playerReady = true
      });
    }
  }
};
</script>